<template lang="pug">
base-container
  el-dialog(
    title="定向推送",
    width="60%"
    :visible.sync="box",
    v-dialogdrag
  )
    push-user-list(ref="pushUser", @pushSelectonChange="pushSelectionChange")
    span.dialog-footer(slot="footer")
      el-button.mr8(@click="cancelPush") 取 消
      el-button(type="primary", @click="pushPartUser") 确定
  //- 推送记录弹窗
  el-dialog(
    title="推送记录",
    :visible.sync="pushedBox",
    :init-row="row"
    v-dialogdrag
  )
    pushed-list(ref="pushedList")
    span.dialog-footer(slot="footer")
      el-button.mr8(@click="cancelPushedModal") 取 消
      el-button(type="primary", @click="pushPartUser") 推送
  avue-crud(
    ref="crud",
    :data="data",
    :table-loading="loading",
    :option="option",
    :page.sync="page",
    @search-change="searchChange",
    @search-reset="searchReset",
    @current-change="currentChange",
    @size-change="sizeChange",
    @refresh-change="refreshChange",
    @on-load="onLoad"
  )
    template(slot="showType", slot-scope="{row}")
      el-tag {{ findTagName(row) }}
    template(slot="pushStatus", slot-scope="{row}")
      el-tag {{ row.pushStatus === 0 ? '暂存' : row.pushType===1?"已发布-全站":row.pushType===2?"已发布-定向":"已发布" }}
    template(slot-scope="scope", slot="menuLeft")
      el-button(
        type="primary",
        icon="el-icon-plus",
        size="small",
        plain,
        @click.stop="handleAdd"
      ) 新增
    template(slot-scope="{row,index}", slot="menu")
      el-button.none-border(
        v-if="row.pushStatus === 0",
        icon="el-icon-sort-up",
        type="text",
        size="small",
        plain,
        @click.stop="showModal(row)"
      ) 定向推送
      el-button.none-border(
        v-if="row.pushStatus === 0",
        icon="el-icon-sort",
        type="text",
        size="small",
        plain,
        @click.stop="pushAll(row, index)"
      ) 全站推送
      el-button.none-border(
        icon="el-icon-view",
        type="text",
        size="small",
        plain,
        @click.stop="rowView(row, index)"
      ) 查看
      el-button.none-border(
        icon="el-icon-edit",
        type="text",
        size="small",
        plain,
        @click.stop="rowUpdate(row, index)"
      ) 更新
      el-button.none-border(
        v-if="row.pushStatus === 0",
        icon="el-icon-delete",
        type="text",
        size="small",
        plain,
        @click.stop="rowDel(row, index)"
      ) 删除
      el-button.none-border(
        v-if="row.pushStatus === 1 && row.pushType===2",
        icon="el-icon-finished",
        type="text",
        size="small",
        plain,
        @click.stop="showPushedListModal(row)"
      ) 推送列表
</template>
<script>
/**
 * 内容管理-协议管理-列表
 */
const CONFIRM_TITLE = '确定将所选数据删除？'
import { find } from 'ramda'
import PushUserList from './push-userlist'
import PushedList from './pushed-list'
import { getAnnounceList, delAnnounce, doPushAnnounce } from '@/api/announce'
import {
  pushStatusEnum,
  showTypeEnum,
  isRegisterEnum
} from './const'
export default {
  name: 'Announce',
  components: {
    PushUserList,
    PushedList
  },
  data() {
    return {
      pushedBox: false,
      pushUserSelectionList: [],
      box: false,
      row: {},
      form: {},
      data: [],
      query: {},
      loading: false,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      option: {
        indexLabel: '序号',
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        editBtnText: '更新',
        searchShow: true,
        columnBtn: false,
        searchBtnText: '查询',
        emptyBtnText: '重置',
        stripe: true,
        searchSpan: 8,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menuWidth: 320,
        menu: true,
        labelWidth: 10,
        column: [
          {
            label: '公告标题',
            prop: 'title',
            search: true,
            overHidden: true,
            width: 260,
            editDisplay: false
          },
          {
            label: '展现方式',
            prop: 'showType',
            editDisplay: false,
            search: true,
            type: 'select',
            slot: true,
            dicData: showTypeEnum,
            overHidden: true,
            width: 150
          },
          {
            label: '发布状态',
            editDisplay: false,
            prop: 'pushStatus',
            search: true,
            slot: true,
            type: 'select',
            dicData: pushStatusEnum,
            overHidden: true,
            width: 120
          },
          {
            label: '是否注册发送',
            editDisplay: false,
            prop: 'isRegister',
            search: true,
            slot: true,
            type: 'select',
            dicData: isRegisterEnum,
            overHidden: true,
            width: 120
          },
          {
            label: '创建时间',
            editDisplay: false,
            prop: 'createDate',
            overHidden: true,
            width: 160
          },
          {
            label: '发布时间',
            prop: 'pushDate',
            type: 'daterange',
            editDisplay: false,
            width: 160
          }
        ]
      }
    }
  },
  computed: {
    userIds() {
      const ids = []
      this.pushUserSelectionList.forEach((ele) => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    showModal(row) {
      this.row = row
      this.box = true
      if (this.$refs.pushUser) {
        this.$refs.pushUser.selectionClear()
      }
    },
    showPushedListModal(row) {
      this.$store.commit('announce/setCurrentRow', { row })
      this.row = row
      this.pushedBox = true
    },
    cancelPushedModal() {
      this.pushedBox = false
    },
    pushPartUser(scope) {
      const { id } = this.row
      const { userIds } = this
      if (userIds) {
        this.$confirm('确认进行定向推送？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            doPushAnnounce({
              announceId: id,
              userIds,
              pushType: 2
            }).then((res) => {
              this.box = false
              this.$message({
                type: 'success',
                message: '操作成功',
                onClose: () => {
                  this.onLoad(this.page)
                }
              })
            })
          })
          .catch(() => {
            this.box = false
            this.selectionList = []
            this.$message({
              type: 'info',
              message: '已取消定向推送'
            })
          })
      }
    },
    pushSelectionChange(list) {
      this.pushUserSelectionList = list
    },
    beforePushClose() {
      this.$refs.pushUser.selectionClear()
    },
    cancelPush() {
      this.$refs.pushUser.selectionClear()
      this.box = false
    },
    pushAll(row) {
      const { id } = row
      if (id) {
        this.$confirm('确认进行全站推送？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          doPushAnnounce({ announceId: id, pushType: 1 })
            .then((res) => {
              this.$message({
                type: 'success',
                message: '操作成功',
                onClose: () => {
                  this.onLoad(this.page)
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消全站推送'
              })
            })
        })
      }
    },
    handlePushedList(row, index) {
      const { id } = row
      this.$router.push({
        path: '/content/announce/pushed-list',
        query: {
          recordId: id
        }
      })
    },
    findTagName(row) {
      return find((x) => x.value === row.showType)(showTypeEnum).label
    },
    rowView(row) {
      const { id } = row
      this.$router.push({ path: '/content/announce/detail', query: { id }})
    },
    rowUpdate(row, index, loading, done) {
      const { id } = row
      this.$router.push({
        path: '/content/announce/add-or-update',
        query: { id }
      })
    },
    handleAdd() {
      this.$router.push({
        path: '/content/announce/add-or-update',
        query: { id: null }
      })
    },
    rowDel(row) {
      const { id } = row
      this.$confirm(CONFIRM_TITLE, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delAnnounce({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功',
            onClose: () => {
              this.onLoad(this.page)
            }
          })
        })
      })
    },
    selectionChange(list) {
      this.selectionList = list
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      const { createDate } = params
      let values = { ...params }
      if (createDate) {
        values = {
          ...params,
          createDateStart: createDate[0],
          createDateEnd: createDate[1]
        }
        values.createDate = null
        this.query.createDate = null
      }
      this.loading = true
      getAnnounceList(page.currentPage, page.pageSize, {
        ...values,
        ...this.query
      })
        .then((res) => {
          this.page.total = res.total
          this.data = res.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
